export default {
    SaveToCloudProgressManager: {
        datapoint: {
            name: 'SaveToCloudProgressManager',
            customData: (operationId: string, counter: number): any => ({
                operationId: operationId,
                counter: counter,
            }),
        },
    },
};
